import Vue from 'vue';
import {mapActions} from 'vuex';

const baseAppMixin = {
  created() {
    this.getMessageTokenAndCount();
  },
  computed: {
    profile() {
      return this.$store.state.user.profile;
    }
  },
  methods: {
    ...mapActions(['GET_MESSAGE_LIST']),
    async getMessageTokenAndCount() { // 获取message-token
      try {
        const res = await Vue.axios({
          baseURL: `${feConfig.api.base}`,
          withCredentials: true
        }).post('/v1/users/message-token');
        if (res.code === 1101) {
            window.location.href = '/';
            return;
        }
        if (res.code !== 0) {
          return this.$handleError({}, `Message Server Error: HTTPS Status ${res.status}`);
        }
        const token = res.data.data.token;
        if (!token) {
          return console.log(`Message Server Error: Token Get Failed ${res.data.msg ? '- ' + res.data.msg : ''}`);
        }
        window.sessionStorage.setItem('message_token', token);
        this.GET_MESSAGE_LIST(token);
      } catch (err) {
        this.$handleError(err);
      }
    }
  },
  beforeDestroy() {
    window.sessionStorage.removeItem('message_token');
  },
  watch: {
    $route() {
      if (this.profile.userId || this.profile.user_id || this.profile.id) {
        this.getMessageTokenAndCount();
      }
    }
  }
};

export default baseAppMixin;




// WEBPACK FOOTER //
// ./src/views/index/mixin/baseAppMixin.js